module.exports = __webpack_public_path__ + "img/services.b165e1af.svg";